<div>
    <form [formGroup]="groupDetailForm">
        <mat-card>
            <h4>Add New Group</h4>
            <mat-card-content>
                <mat-form-field style="width: 250px;" appearance="fill">
                    <mat-label>Code</mat-label>
                    <input matInput matInput formControlName="code" placeholder="Code" autocomplete="off" readonly>
                </mat-form-field>
                <mat-form-field style="width: 250px;" appearance="fill">
                    <mat-label>Name</mat-label>
                    <input matInput matInput formControlName="name" placeholder="Name" autocomplete="off" required
                           (blur)="trimControl(name)">
                    <mat-error *ngIf="name.hasError('required') && name.touched && name.invalid">Name is required</mat-error>
                </mat-form-field>
                <mat-card-actions>
                    <button mat-button color="cancel" (click)="cancel()">CANCEL</button>
                    <button mat-button color="primary" (click)="save()">SAVE</button>
                </mat-card-actions>
            </mat-card-content>
        </mat-card>
    </form>
</div>